

export class PoiVehicleOutputWithStatus implements IPoiVehicleOutputWithStatus {
    /** The auto-generated id of the poi vehicle master */
    poi_vehicle_id!: number;
    /** The auto-generated id of the poi master */
    poi_details_id!: number;
    /** The place name with 255 character limit */
    place_name!: string;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id!: number;
    /** The vehicle number with vehicle name */
    vehicle_number!: string;
    /** Manage status of alert type. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IPoiVehicleOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poi_vehicle_id = _data["poi_vehicle_id"];
            this.poi_details_id = _data["poi_details_id"];
            this.place_name = _data["place_name"];
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.vehicle_number = _data["vehicle_number"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PoiVehicleOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new PoiVehicleOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poi_vehicle_id"] = this.poi_vehicle_id;
        data["poi_details_id"] = this.poi_details_id;
        data["place_name"] = this.place_name;
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["vehicle_number"] = this.vehicle_number;
        data["status"] = this.status;
        return data; 
    }
}

export interface IPoiVehicleOutputWithStatus {
    /** The auto-generated id of the poi vehicle master */
    poi_vehicle_id: number;
    /** The auto-generated id of the poi master */
    poi_details_id: number;
    /** The place name with 255 character limit */
    place_name: string;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id: number;
    /** The vehicle number with vehicle name */
    vehicle_number: string;
    /** Manage status of alert type. 0 For De-active, 1 For Active */
    status: number;
}

